import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Dropdown, DropdownButton, Row } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';

type StatusApontamentoType = {
  id: string;
  label: string;
};

type ListProfessionalType = {
  id: number;
  name: string;
};

interface CalendarioCardProps {
  professionals: ListProfessionalType[];
  statuses: StatusApontamentoType[];
  numeroCalendario: number;
}

const CalendarioFilterComponent: React.FC<CalendarioCardProps> = ({ professionals, statuses, numeroCalendario }) => {
  const [selectedProfessionals, setSelectedProfessionals] = useState<ListProfessionalType[]>([]);
  const [selectedStatuses, setSelectedStatuses] = useState<StatusApontamentoType[]>([]);

  // Função para salvar seleções no localStorage
  const saveToLocalStorage = (key: string, value: any) => {
    localStorage.setItem(key, JSON.stringify(value));
  };

  // Função para carregar seleções do localStorage
  const loadFromLocalStorage = (key: string) => {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  };

  // Carregar seleções do localStorage ao inicializar
  useEffect(() => {
    const savedProfessionals = loadFromLocalStorage(`calendario_selected_professionals_${numeroCalendario}`);
    const savedStatuses = loadFromLocalStorage(`calendario_selected_statuses_${numeroCalendario}`);

    if (savedProfessionals) {
      setSelectedProfessionals(savedProfessionals);
    }
    if (savedStatuses) {
      setSelectedStatuses(savedStatuses);
    }
  }, [numeroCalendario]);

  // Atualizar localStorage quando as seleções mudarem
  useEffect(() => {
    saveToLocalStorage(`calendario_selected_professionals_${numeroCalendario}`, selectedProfessionals);
  }, [selectedProfessionals, numeroCalendario]);

  useEffect(() => {
    saveToLocalStorage(`calendario_selected_statuses_${numeroCalendario}`, selectedStatuses);
  }, [selectedStatuses, numeroCalendario]);

  const handleSelectProfessional = (prof: ListProfessionalType) => {
    if (!selectedProfessionals.some((p) => p.id === prof.id)) {
      const updatedProfessionals = [...selectedProfessionals, prof];
      setSelectedProfessionals(updatedProfessionals);
    }
  };

  const handleRemoveProfessional = (prof: ListProfessionalType) => {
    const updatedProfessionals = selectedProfessionals.filter((p) => p.id !== prof.id);
    setSelectedProfessionals(updatedProfessionals);
  };

  const handleSelectStatus = (status: StatusApontamentoType) => {
    if (!selectedStatuses.some((s) => s.id === status.id)) {
      const updatedStatuses = [...selectedStatuses, status];
      setSelectedStatuses(updatedStatuses);
    }
  };

  const handleRemoveStatus = (status: StatusApontamentoType) => {
    const updatedStatuses = selectedStatuses.filter((s) => s.id !== status.id);
    setSelectedStatuses(updatedStatuses);
  };

  return (
    <Row>
      <Col style={{ margin: '5px' }}>
        <Card>
          <Card.Header>
            <div className="d-flex justify-content-between align-items-center">
              <span>Calendário</span>
            </div>
          </Card.Header>

          <Card.Body>
            <Card.Title>Profissionais e Status</Card.Title>

            <DropdownButton id="dropdown-professionals" title="Selecionar Profissionais" variant="outline-primary" size="sm">
              {professionals.map((prof, index) => (
                <Dropdown.Item key={index} as="button" onClick={() => handleSelectProfessional(prof)}>
                  {prof.name}
                </Dropdown.Item>
              ))}
            </DropdownButton>
            <div>
              {selectedProfessionals.map((prof, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <Button
                    variant="light"
                    size="sm"
                    style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
                    onClick={() => handleRemoveProfessional(prof)}>
                    <span>{prof.name}</span>
                    <FaTimes />
                  </Button>
                </div>
              ))}
            </div>

            <DropdownButton id="dropdown-status" title="Selecionar Status" style={{ marginTop: '10px' }} variant="outline-primary" size="sm">
              {statuses.map((status, index) => (
                <Dropdown.Item key={index} as="button" onClick={() => handleSelectStatus(status)}>
                  {status.label}
                </Dropdown.Item>
              ))}
            </DropdownButton>
            <div style={{ paddingTop: '5px' }}>
              {selectedStatuses.map((status, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <Button variant="light" size="sm" style={{ display: 'flex', alignItems: 'center', gap: '5px' }} onClick={() => handleRemoveStatus(status)}>
                    <span>{status.label}</span>
                    <FaTimes />
                  </Button>
                </div>
              ))}
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default CalendarioFilterComponent;
